import { useEffect } from 'react';
import { useYbugApi } from 'ybug-react';
import { useProfileStore } from '../store/useProfileStore';
import { ybugSettings } from './ybugSettings';

export const InitYbug: React.FC = () => {
  const ybug = useYbugApi();
  const activeProfile = useProfileStore((s) => s.activeProfile);

  useEffect(() => {
    if (!activeProfile || !ybug || !ybug.Ybug) return;

    const language =
      activeProfile.language ||
      (typeof navigator !== 'undefined' ? navigator.language : undefined);

    // ybug.init() REPLACES window.ybug_settings (see ybug-react source: it
    // does Object.assign({}, settings, {id, onload}) and reassigns the
    // global). Anything we set via YbugProvider's `settings` prop on first
    // mount gets wiped here. Spread `ybugSettings` first so the iOS
    // flow directives (skip_to, onopen, onbeforescreenshot) survive after
    // auth — without this, post-auth opens lose `skip_to: 'feedback'` and
    // the type/annotation chooser comes back even on iOS.
    ybug.init({
      ...ybugSettings,
      feedback: {
        email: activeProfile.email,
        name: activeProfile.displayName,
      },
      ...(language ? { language_override: language } : {}),
      user: {
        id: activeProfile.id,
        name: activeProfile.displayName,
        email: activeProfile.email,
      },
    });
  }, [ybug, activeProfile]);

  return null;
};
